import { ALL, FULL, NONE } from '../constants/common';
import { DISCOVER } from '../constants/partnering-networks';

/**
 * @param {string} network
 * @return {boolean}
 */
function isMANetwork(network) {
  return network === 'MASTERCARD' || network === 'MA';
}

/**
 * converts value
 * @param {object} vInitRequest
 * @param {string} network
 * @return {string}
 */
const getShippingPreference = (vInitRequest, network) => {
  let configValue = vInitRequest?.shipping?.collectShipping;

  // value could be a string 'false' or 'true' so need to check type and convert to boolean
  if (typeof configValue === 'string') {
    configValue = configValue === 'true';
  }

  if (isMANetwork(network) || network === DISCOVER) {
    configValue = configValue ? FULL : NONE;
  } else {
    configValue = configValue ? ALL : NONE;
  }

  return configValue;
};

export default getShippingPreference;
